import { Box, Paper, SxProps } from "@mui/material";
import { useState } from "react";

import { MapPillHeader } from "./MapPillHeader";

type MapPillProps = {
    title: string;
    icon: React.ReactNode;
    children: React.ReactNode;
    sx?: SxProps;
    hasDot: boolean;
};

export function MapPillPanel({ title, icon, children, sx, hasDot }: MapPillProps) {
    const [open, setOpen] = useState(false);
    return (
        <Paper
            sx={theme => ({
                borderBottom: `1px solid ${theme.palette.divider}`,

                // we use grid in order to transition the panel open and close
                // this is a workaround, you cannot transition to/from "height: auto"
                display: "grid",
                gridTemplateRows: open ? "40px 1fr" : "40px 0fr",
                gridTemplateColumns: open ? "1fr" : "0fr",
                transition: theme.transitions.create("all", {
                    duration: theme.transitions.duration.shorter,
                }),
                borderRadius: open ? "4px" : "40px",
                flexShrink: open ? 1 : 0,
                minHeight: "40px",

                width: "fit-content",

                ...{ sx },
            })}
        >
            <MapPillHeader
                icon={icon}
                title={title}
                open={open}
                onOpenToggle={() => setOpen(prevOpen => !prevOpen)}
                hasDot={hasDot}
            />

            <Box
                sx={theme => ({
                    gridColumn: "1 / -1",

                    transition: theme.transitions.create("opacity", {
                        duration: theme.transitions.duration.shorter,
                    }),
                    opacity: open ? 1 : 0,

                    borderTop: open ? `1px solid ${theme.palette.divider}` : "none",

                    overflow: "auto",
                    minHeight: 0,
                })}
            >
                <Box sx={{ width: "330px" }}>{children}</Box>
            </Box>
        </Paper>
    );
}
